import type { RedoCart } from "@redotech/merchant-sdk/rpc/schema/redo-supplies/redo-cart";

const FREE_ITEM_PROMOTION_ATTRIBUTE = "suppliesPromotionId";

export function suppliesCartAnalytics(cart: RedoCart | null | undefined) {
  const items = cart?.items ?? [];
  return {
    cartItemCount: items.length,
    cartQuantity: items.reduce((sum, item) => sum + item.quantity, 0),
    cartSubtotal: items.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0,
    ),
    currency: items[0]?.currency,
    hasDestinationLocation: cart?.destinationLocationId != null,
    hasFreeItem: items.some((item) =>
      item.attributes.some(
        (attribute) => attribute.key === FREE_ITEM_PROMOTION_ATTRIBUTE,
      ),
    ),
    hasInventoryTriggeredItem: items.some((item) =>
      item.attributes.some((attribute) => attribute.key === "reorderThreshold"),
    ),
    hasSubscriptionItem: items.some((item) =>
      item.attributes.some((attribute) => attribute.key === "orderInterval"),
    ),
  };
}

export function fundingSourceAnalytics(reference: {
  source: string;
  priority?: string;
}) {
  return {
    paymentSource: reference.source,
    paymentPriority: reference.priority,
  };
}
